import { ACCESS_TOKEN_NAME, JSON_CONTENT_TYPE } from '../constant/constants';
import { IApiParams } from '../interface/IApiParams';
import { getApi } from './getApi';

export const apiGetLection = async (
  section: string,
  lection: string,
  main: string,
  secondary: string,
  secondaryBlack: string
) => {
  const params: IApiParams = {
    url: `/api/lections.php?section=${section}&lection=${lection}&mainColor=${main}&secondaryColor=${secondary}&secondaryColorBlack=${secondaryBlack}`,
    headers: {
      'Content-Type': JSON_CONTENT_TYPE,
      'Access-Token': localStorage.getItem(ACCESS_TOKEN_NAME),
    },
  };
  return getApi(params, 'GET');
};
